import * as React from 'react';
import { Router, Route, Switch } from 'react-router-dom';
import { history } from '../../store';

import { ChatRouteHandler } from '../../components/chat-route-handler';
import { ROUTES } from '../../constants/routes';
import { Chat } from '../chat';
import { ChatEnd } from '../chat-end';
import { Inquiry } from '../inquiry';
import { Login } from '../login';
import { FeedBackForOperator } from '../operator/feedback';
import { OperatorInfo } from '../operator/info';
import { ThankYou } from '../thank-you';
import { WaitingForOperator } from '../waiting-screen';

import useDynamicTitle from './use-dynamic-titple';

export const App = () => {
  useDynamicTitle();

  return (
    <Router history={history}>
      <ChatRouteHandler />
      <Switch>
        <Route exact path={ROUTES.ROOT} component={WaitingForOperator} />
        <Route exact path={ROUTES.WAITING_FOR_OPERATOR} component={WaitingForOperator} />
        <Route exact path={ROUTES.LOGIN} component={Login} />
        <Route exact path={ROUTES.CHAT} component={Chat} />
        <Route exact path={ROUTES.CHAT_END} component={ChatEnd} />
        <Route exact path={ROUTES.OPERATOR_INFO} component={OperatorInfo} />
        <Route exact path={ROUTES.OPERATOR_FEEDBACK} component={FeedBackForOperator} />
        <Route exact path={ROUTES.THANK_YOU} component={ThankYou} />
        <Route exact path={ROUTES.INQUIRY} component={Inquiry} />
      </Switch>
    </Router>
  );
};

export default App;
